var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFileWord = function SvgDownloadFileWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD1B9",
    fillRule: "evenodd",
    d: "m26.286 10.288-8.002-8.002H8.114a2.4 2.4 0 0 0-2.4 2.4v22.629a2.4 2.4 0 0 0 2.4 2.4h15.772a2.4 2.4 0 0 0 2.4-2.4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9A476",
    d: "M18.284 10.286v-8l8 8zM16.77 14.024a.683.683 0 0 1 .857.666v10.62a.683.683 0 0 1-.857.666l-6.265-1.7A.69.69 0 0 1 10 23.61v-7.22c0-.312.207-.585.505-.666zm3.342 1.69c.49 0 .888.448.888 1v6.572c0 .552-.398 1-.888 1h-.762c-.49 0-.889-.448-.889-1v-6.572c0-.552.398-1 .889-1zm-7.597 6.218h.679l.613-2.312h.014l.61 2.312h.68l.881-3.45h-.72l-.528 2.472h-.013l-.613-2.472h-.611l-.612 2.472h-.014l-.525-2.472h-.722z"
  })));
};
export default SvgDownloadFileWord;